module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v(_vm._s(_vm.title)), _c('br'), _vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))]), _c('div', {
    attrs: {
      "id": _vm.id + '_chart'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55098da9","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/elements/BarChart.vue
// module id = 521
// module chunks = 1